import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            实时更新
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            热门漫画每日同步更新，精彩内容不错过
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updateItems.map((item, idx) => (
              <div
                key={item.id}
                className={`relative pb-8 ${idx === updateItems.length - 1 ? 'pb-0' : ''}`}
              >
                <div className="absolute -left-[33px] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                  <div className="flex items-center gap-3 flex-wrap mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span
                      className={`px-2 py-0.5 text-xs font-medium rounded ${
                        item.tag === '最新'
                          ? 'bg-accent-100 text-accent-700'
                          : item.tag === '热更'
                            ? 'bg-primary-100 text-primary-700'
                            : item.tag === '新作'
                              ? 'bg-secondary-100 text-secondary-700'
                              : 'bg-background-200 text-foreground-500'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <p className="text-sm text-foreground-500 mt-1.5 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}